
































import {Vue, Component, Watch} from 'vue-property-decorator';
import SearchStore from '@/store/SearchStore.brain';
import DetailStore from '@/store/DetailStore';

import LeftTree from './poi-left-tree.vue';
import LeftWordCloud from './poi-left-word-cloud.vue';
import UserLeftMap from './user/user-left-map.vue';

@Component({
    components: {LeftTree, LeftWordCloud, UserLeftMap}
})
export default class PoiLeft extends Vue {
    searchData = SearchStore.state;
    detailData = DetailStore.state;
    get entityType() {return this.searchData.searchItem.entityType}
    get detailDataR() {return this.detailData}
    get userData() {return this.detailData.userData}
    get poiData() {return this.detailData.poiData}
    cancelToken: any;
    aef: any;

    poiTreeStatus = autoAnimation ? 'fly-out' : 'fly-in';
    poiWordCloudStatus = autoAnimation ? 'fly-out' : 'fly-in';

    *actionScriptPoiLeft (isQuick) {
        if (isQuick) {
            this.poiTreeStatus = 'fly-in';
            this.poiWordCloudStatus = 'fly-in';
            return void 0;
        }
        this.poiTreeStatus = 'fly-in';
        yield this.$sleep(500);
        this.poiWordCloudStatus = 'fly-in';
    }

    mounted () {
        this.cancelToken = new this.$ae.CancelToken();
        this.aef = this.$ae(this.actionScriptPoiLeft, this.cancelToken);
        this.$autoOn('poi-left-start', this.aef);
    }

    destory () {
    }
}
